import { createEntityAdapter } from '@reduxjs/toolkit';
import { ManageWithdrawState } from './interfaces';
import { ManageWithdrawStoreStatus } from './enums';
import { WithdrawRequestEntity } from 'app/interfaces/entity';
import { DEFAULT_LIMIT } from './constants';

export const entityAdapter = createEntityAdapter<WithdrawRequestEntity>({
  selectId: (data) => data.id,
});

export const initialState: ManageWithdrawState = entityAdapter.getInitialState({
  status: {
    [ManageWithdrawStoreStatus.Loading]: [],
    [ManageWithdrawStoreStatus.UpdatingOne]: [],
  },
  limit: DEFAULT_LIMIT,
  offset: 1,
  total: 0,
  reload: true,
});
